import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { Dokument } from '../../domain/model/dokument';
import { Zuweisung } from '../../domain/model/zuweisung';

@Injectable()
export abstract class UpAndDownloadComponent {
    protected http = inject(HttpClient);

    public uploading = false;
    public uploadProgress = 0;
    public numberOfFilesToUpload = 0;
    public numberOfUploadedFiles = 0;

    // die IDE zeigt diese Funktions vielleicht aus nicht verwendet ab
    // sie wird aber als Callback im AufgabeService aufgerufen
    public handleUploadEvent(event: any) {
        switch (event.type) {
            case HttpEventType.Sent:
                this.uploading = true;
                break;
            case HttpEventType.UploadProgress:
                this.uploadProgress = Math.round(100 * event.loaded / event.total);
                break;
            case HttpEventType.Response:
                this.uploading = false;
                break;
            default:
                console.log('unknown event');
        }
    }

    protected createAndClickDownloadLink(element: Dokument | Zuweisung, fileDownloadUrl: string) {
        element.downloading = true;
        this.http.get(fileDownloadUrl,
            {
                responseType: 'blob',
                observe: 'response',
            }).subscribe(resp => {
            const contentDisposition = resp.headers.get('Content-Disposition');
            const filename = contentDisposition.split(';')[1]
                .split('filename')[1].split('=')[1].replace(/"/g, '').trim();

            const downloadLink = document.createElement('a');
            downloadLink.href = window.URL.createObjectURL(resp.body);
            downloadLink.setAttribute('download', filename);
            document.body.appendChild(downloadLink);
            downloadLink.click();
            element.downloading = false;
            URL.revokeObjectURL(downloadLink.href);
        });
    }
}
